import React from 'react';
import SubscriptionsCard from "../../Components/SubscriptionsCard/index";
import AuthenticatedTemplate from "../../Components/Templates/Authenticated/index";
import CreditCardInfo from '../../Components/CreditCardInfo';
import { Grid, StatsCard } from 'tabler-react';
import FeaturedButton from '../../Components/FeaturedButton';

const Home = () => {
    return (
        <AuthenticatedTemplate title="Início">
            {/*<Grid.Row>*/}
            {/*    <Grid.Col width="6">*/}
            {/*        <StatsCard layout={2} movement={5} total={430} label="Visitas esta semana"/>*/}
            {/*    </Grid.Col>*/}

            {/*    <Grid.Col width="6">*/}
            {/*        <StatsCard layout={2} movement={18} total={700} label="Aparições em pesquisas"/>*/}
            {/*    </Grid.Col>*/}
            {/*</Grid.Row>*/}

            <Grid.Row>
                <Grid.Col width={12} md={6}>


                    <Grid.Row>
                        <FeaturedButton
                            icon="check"
                            title="Assinaturas"
                            href="/subscriptions"
                            size={6}
                        />
                        <FeaturedButton
                            icon="help-circle"
                            title="Ajuda"
                            size={6}
                            href="https://ooppah.zendesk.com/hc/pt-br"
                            target="_blank"
                        />
                        <FeaturedButton
                            icon="mail"
                            title="Alterar E-mail"
                            href="/change-email"
                            size={6}
                        />
                        <FeaturedButton
                            icon="lock"
                            title="Alterar Senha"
                            href="/change-password"
                            size={6}
                        />
                        <FeaturedButton
                            icon="phone"
                            title="Alterar Telefone"
                            href="/change-phone"
                            size={6}
                        />
                        <FeaturedButton
                            icon="home"
                            title="Alterar Endereço"
                            href="/change-address"
                            size={6}
                        />

                    </Grid.Row>
                </Grid.Col>

                <Grid.Col  width={12} md={6}>
                    <CreditCardInfo fromHome={true} />
                </Grid.Col>
            </Grid.Row>

            <SubscriptionsCard />
        </AuthenticatedTemplate>
    );
};

export default Home;
